export const USER_PROFILE_LOADED = "USER_PROFILE_LOADED";
export const ORGANISATION_LOADED = "ORGANISATION_LOADED";
export const ORGANISATIONS_LOADED = "ORGANISATIONS_LOADED";
export const ORGANISATION_SET_ORGANISATION = "ORGANISATION_SET_ORGANISATION";
export const ORGANISATION_LOADING = "ORGANISATION_LOADING";
export const ORGANISATIONS_SET_MEMBERSHIP = "ORGANISATIONS_SET_MEMBERSHIP";
export const ORGANISATIONS_SET_MODULES = "ORGANISATIONS_SET_MODULES";
